
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      modalName: String,
      modalTitle: String,
    },
  });
